import * as React from 'react';
import './rangePenetrationChart.scss';
import { isValidNumber, constrainToRange, determinePercentageIntoRange } from 'utils/numberUtils';

export interface IRangePenetrationChartProps {
    pay: number;
    min: number;
    max: number;
    className?: string;
}

class RangePenetrationChart extends React.Component<IRangePenetrationChartProps> {
    constructor(props: IRangePenetrationChartProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { min, max, pay } = this.props;
        const className = this.props.className || '';
        // provide actual numbers that make sense, please
        if (!isValidNumber(min) ||
            !isValidNumber(max) ||
            !isValidNumber(pay) ||
            min >= max ||
            max <= 0
        ) {
            return null;
        }

        // positive numbers and zeroes only, please
        const minNum = min <= 0 ? 0 : min;
        const maxNum = max;
        const payNum = pay <= 0 ? 0 : pay;

        const percentageIntoRange = determinePercentageIntoRange(payNum, maxNum, minNum);
        const overRangeClass = percentageIntoRange > 100 ? 'range-penetration-chart--over-range' : '';
        const underRangeClass = percentageIntoRange < 0 ? 'range-penetration-chart--under-range' : '';
        const combinedClass = `${className} ${underRangeClass} ${overRangeClass}`;
        // for styling purposes max out at 100, min out at 0
        const rangeFilledStyle = {
            left: `${constrainToRange(percentageIntoRange)}%`
        };
        return (
            <div className={`range-penetration-chart ${combinedClass}`}>
                <div className="range-penetration-chart__bar">
                    <div className="range-penetration-chart__marker" style={rangeFilledStyle} />
                </div>
            </div>
        );
    }
}

export default RangePenetrationChart;